import React from 'react';
import PropTypes from 'prop-types';

import * as Styled from './InformationCard.styled';

/**
 * Organizes information into sections on a page
 */
const InformationCard = ({ header, children, withDivider, className }) => (
  <Styled.InformationCard className={className}>
    <Styled.Header>{header}</Styled.Header>
    {withDivider && <Styled.Divider />}
    <Styled.Content>{children}</Styled.Content>
  </Styled.InformationCard>
);

InformationCard.propTypes = {
  /**
   * displays a divider between the header and content if `true`
   */
  withDivider: PropTypes.bool,
  /**
   * component to be rendered within the header
   */
  header: PropTypes.node.isRequired,
  /**
   * component to be rendered as content
   */
  children: PropTypes.node.isRequired,
  /**
   * CSS class name
   */
  className: PropTypes.string
};

InformationCard.defaultProps = {
  withDivider: true,
  className: undefined
};

export default InformationCard;
